import { AbstractControl } from '@angular/forms';
import { BASE_WEBSITE_REGEXP } from '../constants/base-regexp-patterns.const';

export const baseWebsiteValidator = () => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const urlRegex = new RegExp(BASE_WEBSITE_REGEXP);
    if (control.value && !urlRegex.test(control.value)) {
      return { websiteInvalid: true };
    }
    return null;
  };
};
